import { X, Info, Lightbulb } from 'lucide-react';
import { GAME_DIRECTIONS, GameKey } from '../../config/gameDirections';

interface GameDirectionsModalProps {
  gameKey: GameKey;
  onClose: () => void;
}

export function GameDirectionsModal({ gameKey, onClose }: GameDirectionsModalProps) {
  const directions = GAME_DIRECTIONS[gameKey];

  return (
    <div className="fixed inset-0 bg-black/50 z-[60] flex items-end sm:items-center justify-center">
      <div className="bg-white dark:bg-gray-900 rounded-t-xl sm:rounded-xl shadow-xl max-w-md w-full max-h-[80vh] flex flex-col">
        <div className="flex items-center gap-2 px-6 py-4 border-b border-gray-200 dark:border-gray-700 shrink-0">
          <Info className="w-5 h-5 text-indigo-500 shrink-0" />
          <div className="flex-1 min-w-0">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white">{directions.title}</h2>
            <p className="text-xs text-gray-500 dark:text-gray-400 truncate">{directions.tagline}</p>
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 shrink-0"
            aria-label="Close"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        <div className="overflow-y-auto px-6 py-4 space-y-5">
          <section>
            <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">For the DJ</h3>
            <ol className="space-y-1.5 list-decimal list-inside">
              {directions.djSetup.map((step, i) => (
                <li key={i} className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                  {step}
                </li>
              ))}
            </ol>
          </section>

          <section>
            <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">What attendees see</h3>
            <ul className="space-y-1.5">
              {directions.attendeeExperience.map((item, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-gray-400 dark:bg-gray-500 shrink-0" />
                  {item}
                </li>
              ))}
            </ul>
          </section>

          <section>
            <h3 className="text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">Tips</h3>
            <ul className="space-y-1.5">
              {directions.tips.map((tip, i) => (
                <li key={i} className="flex items-start gap-2 text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
                  <Lightbulb className="w-4 h-4 text-amber-400 shrink-0 mt-0.5" />
                  {tip}
                </li>
              ))}
            </ul>
          </section>
        </div>
      </div>
    </div>
  );
}
